import {type Type} from '@wandb/weave/core';
import React, {useMemo} from 'react';

import {WeaveFormatContext} from '../WeaveFormatContext';
import {getColumnCellFormats} from './util';

export const WeaveFormatContextProvider = ({
  colType,
  children,
}: {
  colType: Type;
  children: React.ReactNode;
}) => {
  const value = useMemo(() => getColumnCellFormats(colType), [colType]);
  return (
    <WeaveFormatContext.Provider value={value}>
      {children}
    </WeaveFormatContext.Provider>
  );
};
